import {
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogScrollableContent,
  DialogTitle,
  Input,
} from "@win-reality/react-ui";

import { useClipboard } from "@/hooks/use-clipboard";

export interface ViewAccountLinkModal {
  link: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ViewAccountLinkModal({
  link,
  open,
  onOpenChange,
}: ViewAccountLinkModal) {
  const { hasCopied, onCopy } = useClipboard(link);

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => !isOpen && onOpenChange(false)}
      defaultCancelButton={false}
      size="md"
    >
      {({ showDivider, setScrollContainer }) => (
        <>
          <DialogScrollableContent setScrollContainer={setScrollContainer}>
            <DialogHeader>
              <DialogTitle>Account Verification Link</DialogTitle>
            </DialogHeader>

            <div className="grid gap-4">
              <div className="flex gap-2">
                <Input value={link} readOnly />
                <Button variant="secondary-flat-light" onClick={onCopy}>
                  {hasCopied ? "Copied!" : "Copy Link"}
                </Button>
              </div>
            </div>
          </DialogScrollableContent>

          <DialogFooter showDivider={showDivider}>
            <div className="flex w-full justify-center">
              <Button
                variant="ghost"
                onClick={() => onOpenChange(false)}
                className="underline"
              >
                Done
              </Button>
            </div>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
}
